import request from '@/utils/request'

// 获取产品列表
export function getList(params) {
  return request.get('/product/list', { params })
}

// 创建产品信息
export function createOne(data) {
  return request.post('/product/create', data)
}

// 更新产品信息
export function updateOne(data) {
  return request.post('/product/update', data)
}

// 删除产品信息
export function deleteOne(data) {
  const url = '/product/delete/' + data.id
  return request.get(url)
}
